import { __require as _ } from "./_baseExtremum.js";
import { __require as s } from "./_baseIteratee.js";
import { __require as o } from "./_baseLt.js";
var r, i;
function p() {
  if (i) return r;
  i = 1;
  var t = _(), u = s(), n = o();
  function a(e, m) {
    return e && e.length ? t(e, u(m, 2), n) : void 0;
  }
  return r = a, r;
}
export {
  p as __require
};
